module.exports = __webpack_public_path__ + "img/download-top-bg.b66e1aab.png";